import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { JobSkillsSummaryDetails } from '@core/positions-and-skills-types';
import { Theme } from '@core/theme-util';
import { BoxComponent } from '@core/user-interface-legacy';

import { JobSkillsSummaryDetailsChartSectionComponent } from './job-skills-summary-details-chart-section/job-skills-summary-details-chart-section.component';
import { JobSkillsSummaryDetailsHeaderComponent } from './job-skills-summary-details-header/job-skills-summary-details-header.component';
import { JobSkillsSummaryDetailsSkillsSectionComponent } from './job-skills-summary-details-skills-section/job-skills-summary-details-skills-section.component';

@Component({
  selector: 'rt-job-skills-summary-details',
  templateUrl: 'job-skills-summary-details.component.html',
  styleUrls: ['./job-skills-summary-details.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BoxComponent,
    JobSkillsSummaryDetailsHeaderComponent,
    JobSkillsSummaryDetailsChartSectionComponent,
    JobSkillsSummaryDetailsSkillsSectionComponent,
  ],
})
export class JobSkillsSummaryDetailsComponent {
  public readonly jobSkillsSummary = input.required<JobSkillsSummaryDetails>();
  public readonly candidateId = input.required<number>();
  public readonly showJobTitle = input(false);
  public readonly showPositionButton = input(true);
  public readonly theme = input.required<Theme>();

  public readonly viewPosition = output<string>();
  public readonly hiddenCounterClick = output();

  protected onViewPosition() {
    this.viewPosition.emit(this.jobSkillsSummary().positionGuid);
  }
}
